export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13208.4117c8f7.jpg";